import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import Logo from "../../../Assets/Logo/Logo.png";

import Enquiry_form from "../../Forms/Header/Enquiry_form";
import ComingSoonModal from "../ComingSoonModal/ComingSoonModal";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [showEnquiryModal, setShowEnquiryModal] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    setMenuOpen(false);
    navigate(`/${sectionId}`);
    
    // Give a tiny tick for layout paint before scrolling if the component needs to mount, 
    // but usually elements are already present here. requestAnimationFrame ensures smoothness.
    requestAnimationFrame(() => {
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  };

  useEffect(() => {
    const validPaths = ["/", "/home", "/products", "/features", "/demo", "/future"];
    if (!validPaths.includes(location.pathname)) {
      setActiveSection("");
      return;
    }

    const sections = document.querySelectorAll("section[id]");

    const handleScroll = () => {
      let scrollY = window.pageYOffset;
      let current = "home"; // default

      sections.forEach((sec) => {
        const top = sec.offsetTop - 200;
        const height = sec.offsetHeight;
        const id = sec.id;

        if (scrollY >= top && scrollY < top + height) {
          current = id;
        }
      });

      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    setTimeout(() => handleScroll(), 150);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  return (
    <>
      <header className="pro-header">


        <div
          className="pro-left"
          onClick={() => {
            if (location.pathname !== "/") {
              navigate("/");
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          style={{ cursor: "pointer" }}
        >
          <img src={Logo} alt="logo" className="pro-logo" />
        </div>

        {/* HAMBURGER */}
        <div className="pro-hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span><span></span><span></span>
        </div>

        {/* NAV LINKS */}
        <nav className={`pro-nav ${menuOpen ? "active" : ""}`}>
          <a href="/home" onClick={(e) => handleNavClick(e, "home")} className={`pro-link ${activeSection === "home" ? "active" : ""}`}>Home</a>
          <a href="/products" onClick={(e) => handleNavClick(e, "products")} className={`pro-link ${activeSection === "products" ? "active" : ""}`}>Products</a>
          <a href="/features" onClick={(e) => handleNavClick(e, "features")} className={`pro-link ${activeSection === "features" ? "active" : ""}`}>Features</a>
          <a href="/demo" onClick={(e) => handleNavClick(e, "demo")} className={`pro-link ${activeSection === "demo" ? "active" : ""}`}>Demo</a>
          <a href="/future" onClick={(e) => handleNavClick(e, "future")} className={`pro-link ${activeSection === "future" ? "active" : ""}`}>Future</a>
        </nav>

        {/* RIGHT BUTTONS */}
        <div className="pro-right">
          <button
            className="pro-btn-store"
            onClick={() => setShowEnquiryModal(true)}
          >
            Store Keeper
          </button>
          <button
            className="pro-btn-consumer"
            onClick={() => window.open("https://play.google.com/store/apps/details?id=com.doubletap.fulupo", "_blank")}
          >
            Consumers
          </button>
        </div>

      </header>

      <Enquiry_form
        isOpen={showEnquiryModal}
        onClose={() => setShowEnquiryModal(false)}
      />
      <ComingSoonModal
        isOpen={showComingSoon}
        onClose={() => setShowComingSoon(false)}
      />
    </>
  );
};

export default Header;
